import { FieldProps } from "@/core/components/Field";
import { lazy, Suspense, useContext } from "react";
import { Box, Theme } from "@mui/system";
import useCustomStyles from "@/core/hooks/useCustomStyles/useCustomStyles";
import { ConfigContext } from "@/core/contexts/ConfigContext";
import { useAnimationData } from "@/core/contexts/AnimationContext/AnimationContext";

const styles = (theme: Theme) => ({
  root: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(1),
    width: "132px",
    height: "132px",
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(1),
      width: "132px",
      height: "132px",
    },
  },
});

const LazyLottie = lazy(() => import("lottie-react"));

export const LottieAnimation = ({ field }: FieldProps) => {
  const { animationFile, alignItems, flipped, brandBased } = field.properties;
  const initialisationConfig = useContext(ConfigContext);

  const classes: any = useCustomStyles(styles);

  const fileName = brandBased
    ? `${initialisationConfig.brandFamily}/${animationFile}`
    : `${animationFile}`;

  const animationData = useAnimationData(fileName);
  return (
    <Box display="flex" flexDirection="row" justifyContent={alignItems}>
      <Suspense fallback={<Box sx={classes?.root} />}>
        <Box sx={classes?.root}>
          <LazyLottie
            style={flipped ? { transform: "scaleX(-1)" } : {}}
            animationData={animationData}
            loop={true}
            autoplay={true}
          />
        </Box>
      </Suspense>
    </Box>
  );
};

export default LottieAnimation;
